import { render, staticRenderFns } from "./KeywordFilters.vue?vue&type=template&id=fba76aa6"
import script from "./KeywordFilters.vue?vue&type=script&lang=js"
export * from "./KeywordFilters.vue?vue&type=script&lang=js"
import style0 from "./KeywordFilters.vue?vue&type=style&index=0&id=fba76aa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports